import React, { ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import { IconType } from "react-icons";
import { IconContext } from "react-icons/lib";
import { BiCaretRight } from "react-icons/bi";
import { ILinkFunc } from "../../lib/util";

export interface IButtonProps {
  /**
   * Show the default right caret icon?
   */
  icon?: boolean;
  /**
   * Render in outline mode without solid fill and using fill color for text.
   */
  line?: boolean;
  /**
   * Optional custom linking function
   */
  linkFunc?: ILinkFunc;
  /**
   * Properties for the rendered link
   */
  linkProps?: React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  >;
}

export const Button: React.FC<IButtonProps> = ({
  icon = false,
  line,
  linkFunc,
  linkProps,
  children,
}) => {
  const buttonProps = {
    ...linkProps,
    className: `${
      line
        ? "text-button-bg bg-button-text border-solid border border-button-bg"
        : "text-button-text bg-button-bg"
    } m-0.5 px-5 py-2 align-middle text-center inline-block cursor-pointer ${
      linkProps?.className
    }`,
    children: (
      <>
        {children}
        {(icon || icon === undefined) && (
          <BiCaretRight className="ml-1.5 align-middle" />
        )}
      </>
    ),
  };
  return (
    <IconContext.Provider value={{ size: "1.5em", className: "inline-block" }}>
      {linkFunc && linkFunc(buttonProps)}
      {!linkFunc && <a {...buttonProps} />}
    </IconContext.Provider>
  );
};

export default Button;
